import BaseService from "src/packages/BaseService";

export default class CategoryService {
  static async fetch(gameId) {
    const response = await BaseService.getPublicService().get(`game/${gameId}/categories`);
    return response.data;
  }


}
